import { ILinkedin, ILinkedinDto, ILinkedinMedia, ILinkedinMediaDto } from '../common/model/linkedin.model';

const initDatesCommon = (linkedin: ILinkedin): ILinkedin => {
  return {
    ...linkedin
  };
};

export const initDates = (linkedin: ILinkedin): ILinkedin => {
  return {
    ...initDatesCommon(linkedin)
  };
};

const parseLinkedinMedia = (media: ILinkedinMediaDto): ILinkedinMedia => {
  return {
    id: media.id,
    url: media.downloadUrl,
    type: media.type,
    html: '',

    urlExpiresAt: media.urlExpiresAt,

    active: true,

    numPages: 0,
    pageNumber: 1
  };
};

const parseLinkedinPost = (linkedin: ILinkedinDto): ILinkedin => {
  return {
    ...linkedin,

    html: linkedin.commentaryHtml,
    medias: (<Array<any>>linkedin.medias).map((media) => parseLinkedinMedia(media)),

    active: true,
    readMore: false,
    showSpinner: false
  };
};

export const parseLinkedin = (linkedin: ILinkedinDto): ILinkedin => {
  return {
    ...parseLinkedinPost(linkedin)
  };
};
